import React, { useEffect, useState } from "react";
import { sellBoostFetch } from "../../utlifyFunction";
import RecentActivityTable from "../../components/RecentActivityTable";
import ProductHistoryModal from "../../components/Modals/ProductHistoryModal";
import { toast } from "react-toastify";

export default function HistoryTemplate() {
	const [historyData, setHistoryData] = useState(null);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [productToShowHistory, setProductToShowHistory] = useState(null);
	const [restoreButtonLoading, setRestoreButtonLoading] = useState(null);



	const fetchHistory = async () => {
		setHistoryData(null)
		const data = await sellBoostFetch("POST", "/user/getAiHistory", );
		if (data?.history) {
			setHistoryData(data?.history);
		}
	};
	const restoreDescription = async (
			productId,
			newDescription,
			oldDescription
		) => {
			setRestoreButtonLoading(true);
			const response = await sellBoostFetch("POST", "/shopify/updateProduct", {
				productId: productId,
				description: newDescription,
				oldDescription: oldDescription,
			});
			if (response?.status === 200) {
				toast.success("Product description updated!");
				setIsModalOpen(false);
				fetchHistory();
			}
			setRestoreButtonLoading(false);
		};
	useEffect(() => {
		fetchHistory();
	}, []);
	return (
		<div>
			<RecentActivityTable
				recentActivity={historyData}
				setProductToShowHistory={setProductToShowHistory}
				setIsModalOpen={setIsModalOpen}
			/>
			<ProductHistoryModal
				visible={isModalOpen}
				onClose={() => setIsModalOpen(false)}
				product={productToShowHistory}
				restoreDescription={restoreDescription}
				restoreButtonLoading={restoreButtonLoading}
			/>
		</div>
	);
}
